/*
 * Javascript for the home page
*/
(function($) {
	/*$(document).ready(resizeCard);
	$(window).on('resize',resizeCard);

	function resizeCard() {
		if($('.card').length) {
			$('.card').matchHeight({
				byRow: true
			});
			//byRow: true makes pages like this look good: http://eauk.local/news-and-views/page/20
			$('.card .content h4').matchHeight();
		}
		if($('.idea-card').length) {
			$('.idea-card').matchHeight();
		}
	}*/

	//GC Cards
	$(document).on('click', '#share-card-icon', function(){
		title			= $(this).data('title');
		url				= $(this).data('url');
		url_encode		= encodeURI(url);
		title_encode	= encodeURI(title);
		originalHTML = $('#share-card').html();
		console.log(title);
		console.log(title_encode);
		console.log(url_encode);
		console.log(url);
		console.log($('#share-card'));

		$('#share-card').html(originalHTML.replace(/\[\[title\]\]/g,title)
		.replace(/\[\[title_url\]\]/g,title_encode)
		.replace(/\[\[url\]\]/g,url_encode)
		.replace(/\[\[url_link\]\]/g,url));
		$.featherlight($('#share-card'), {
			afterClose: function() {$('#share-card').html(originalHTML); }
		});
		return false;
	});
	$(document).on('click', '.link-btn', function(){
		var copyText = document.getElementById("link-cp");

		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand("copy");
		$('label.copied').removeClass('opacity-0');
		setTimeout(function(){$('label.copied').addClass('opacity-0');},2000);
	});
})(jQuery);
